export default {"src":"/customer-services/_next/static/media/gaming.9b5fb4a3.svg","height":34,"width":40,"blurWidth":0,"blurHeight":0};